var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssign = function SvgAssign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.671 21.009 1.334-1.334-1.334-1.333M20.898 14.012a2.336 2.336 0 0 1 1.111 1.772c0 1.637-2.6 3.035-6.28 3.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.112 14.012a2.336 2.336 0 0 0-1.111 1.772c0 2.15 4.479 3.891 10.004 3.891"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.425 14.043h-6.84a.583.583 0 0 1-.582-.581v-.472a2.441 2.441 0 0 1 2.433-2.434h3.138a2.441 2.441 0 0 1 2.433 2.434v.472a.583.583 0 0 1-.582.581M12.005 7.65A2.325 2.325 0 1 1 12.003 3a2.325 2.325 0 0 1 .002 4.65",
    clipRule: "evenodd"
  })));
};
export { SvgAssign as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYjljNjI3NzQ5ZGUzZGI3ZjYyMTQ2M2UxY2NkYjQxZWEuc3ZnIjs=";